export const SB_CARGANDO = {value: '__cargando__', label: 'Cargando...'};
export const SB_ERROR = {value: '__error__', label: 'Error'};
export const SB_NO_DATA = {value: '__nodata__', label: 'No existen datos para mostrar'};
export const SB_NUEVO = '__isNew__';
export const SB_REGEX_META = /__(.*)__/;
